import httpCreater from '@/utils/httpCreater';
import { Message } from 'element-ui';


const http = httpCreater({
    onFailrue: res => Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
});

export default http;